import React, { useState } from "react";
import { SideMenu, SideMenuItem, SideMenuTop } from "../../../components/components/molecules/SideMenu";
import { IconName } from "@telia/teddy";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import PAGES from "../../../../../constants/pages";
import { getIsInternalTMDealer } from "../../state/selectors/selectors";
import SendFeedbackPanel from "../../components/molecules/SendFeedbackPanel/SendFeedbackPanel";

interface NavigationItem {
    icon: IconName;
    label: string;
    path: string;
    hiddenForInternalTM?: boolean;
}

const navigationItems: NavigationItem[] = [
    {
        label: "Nyheter",
        path: PAGES.RETAILER.SALES_SUPPORT.NEWS.URL,
        icon: "letter",
    },
    {
        label: "Bestill SIM/Materiell",
        path: PAGES.RETAILER.SALES_SUPPORT.ORDER_SIM.URL,
        icon: "simcard",
        hiddenForInternalTM: true,
    },
    {
        label: "Eierskifteskjema",
        path: PAGES.RETAILER.SALES_SUPPORT.OWNERSHIP_TRANSFER.URL,
        icon: "data-transfer",
    },
    {
        label: "Presentasjoner",
        path: PAGES.RETAILER.SALES_SUPPORT.PRESENTATIONS.URL,
        icon: "attachment",
    },
    {
        label: "Skjema",
        path: PAGES.RETAILER.SALES_SUPPORT.FORMS.URL,
        icon: "attachment",
    },
    {
        label: "Provisjonsbulletin",
        path: PAGES.RETAILER.SALES_SUPPORT.COMMISSION_BULLETIN.URL,
        icon: "attachment",
        hiddenForInternalTM: true,
    },
    {
        label: "Rutiner",
        path: PAGES.RETAILER.SALES_SUPPORT.PROCEDURES.URL,
        icon: "attachment",
    },
    {
        label: "Dekningskart",
        path: PAGES.RETAILER.SALES_SUPPORT.COVERAGE_MAP.URL,
        icon: "map",
    },
];

const SalesSupportSidebar: React.FC = () => {
    const location = useLocation();
    const [isReportErrorOpen, setIsReportErrorOpen] = useState(false);
    const isInternalTMDealer = useSelector(getIsInternalTMDealer);
    const visibleItems = navigationItems.filter((item) => !(isInternalTMDealer && item.hiddenForInternalTM));

    return (
        <div className="sidebar">
            <SideMenu className="sidebar__menu">
                <SideMenuTop>
                    {visibleItems.map((item) => (
                        <SideMenuItem
                            label={item.label}
                            color="grey"
                            icon={item.icon}
                            key={item.path}
                            onClick={() => window.location.assign(item.path)}
                            active={location.pathname === item.path}
                        />
                    ))}
                    <SideMenuItem
                        className="sidebar__menu-item--bottom"
                        label="Ny ordre"
                        color="grey"
                        icon="plus"
                        onClick={() => window.location.assign(PAGES.RETAILER.NEWORDER.URL)}
                    />
                    <SideMenuItem
                        label="Gi tilbakemelding"
                        color="grey"
                        icon="send"
                        onClick={() => setIsReportErrorOpen(true)}
                    />
                </SideMenuTop>
            </SideMenu>
            <SendFeedbackPanel open={isReportErrorOpen} onOpenChange={setIsReportErrorOpen} />
        </div>
    );
};

export default SalesSupportSidebar;
